'use client';

import { useEffect, useState } from 'react';

/**
 * Whether the element with this id is on screen, read from an IntersectionObserver.
 * False until the observer first reports (and on the server), so what it gates shows by default.
 */
export function useOnScreen(id: string, active: boolean): boolean {
  const [onScreen, setOnScreen] = useState(false);
  useEffect(() => {
    const el = active ? document.getElementById(id) : null;
    if (!el) return;
    const observer = new IntersectionObserver(([entry]) => setOnScreen(entry.isIntersecting));
    observer.observe(el);
    return () => {
      observer.disconnect();
      setOnScreen(false);
    };
  }, [id, active]);
  return onScreen;
}
